import { StyleSheet } from "react-native";

const ICON_SIDE = 40;

const style = StyleSheet.create({
  icon: {
    height: ICON_SIDE,
    width: ICON_SIDE,
  },
});

export { style };
